import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ToastModule } from 'primeng';
import { PresetRateCardAdminComponent } from './preset-ratecard-admin.component';
import { RateCardsModule } from '../rate-cards/rate-cards.module';
import { RateCardGridModule } from '../rate-cards/rate-card-grid.module';

const routes: Routes = [
  {
    path: '',
    component: PresetRateCardAdminComponent,
    data: { title: 'Rate card presets' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PresetRateCardAdminRoutingModule {}

@NgModule({
  imports: [
    PresetRateCardAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
    RateCardsModule,
    RateCardGridModule,
  ],
  declarations: [PresetRateCardAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PresetRateCardAdminModule {}
